export default __webpack_public_path__ + "static/media/cold-galvanizing-icon-dark.be80d39d.svg";